/* eslint-disable max-len */
import React from 'react';

export default function WithdrawIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <path
        d="M12.9858 22.3594C18.5087 22.3594 22.9858 17.8822 22.9858 12.3594C22.9858 6.83653 18.5087 2.35938 12.9858 2.35938C7.46299 2.35938 2.98584 6.83653 2.98584 12.3594C2.98584 17.8822 7.46299 22.3594 12.9858 22.3594Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.98584 12.3594L12.9858 16.3594L16.9858 12.3594"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9858 8.35938V16.3594"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

WithdrawIcon.propTypes = {};
